import asArray from 'utils/arrays/asArray.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

const isActive = (s) => s.status === 'active';
const hasColumn = (s) => s.has_column || s.hasColumn;

const filterActiveStylistsWithColumn = (stylists) =>
  asArray(stylists)
    .filter(alwaysSame)
    .filter((s) => isActive(s) && hasColumn(s));

export default filterActiveStylistsWithColumn;
